module.exports = __webpack_public_path__ + "img/bgimage.ae97bbd7.webp";